export interface UserDeviceStateModel {
    userDeviceId: number;
    status: string;
    ping: number;
    phoneNumber: string;
    callType: string;
    callCreationTime: Date;
}
